import { assistantStore } from '@f_qwep/components/assistant/store/assistant.store';
import { QwepContext } from '@f_qwep/context/Qwep_context';
import { useAccess } from '@f_qwep/hooks/useAccess';
import { QwepProductEnum } from '@f_qwep/types/QwepProductEnum.type';
import { observer } from 'mobx-react-lite';
import { createContext, PropsWithChildren, useContext, useEffect } from 'react';

const AssistantContext = createContext<{ access: boolean } | null>(null);

const intervalMs = 120000;

const AssistantProvider = observer(({ children }: PropsWithChildren) => {
    const { isAccess: access } = useAccess(QwepProductEnum.ASSISTANT);
    const { tariff } = useContext(QwepContext);

    // Обновление текущего списка
    useEffect(() => {
        let intervalId: NodeJS.Timeout;

        if (access && tariff) {
            assistantStore.firstLoading(tariff).then(() => {
                if (assistantStore.assistantListProfilesStore.currentListProfile?.id) {
                    intervalId = setInterval(async () => {
                        await assistantStore.assistantListProfilesStore.getProfile(
                            assistantStore.assistantListProfilesStore.currentListProfile.id,
                        );
                    }, intervalMs);
                }
            });
        }

        return () => {
            clearInterval(intervalId);
        };
    }, [access, tariff]);

    return <AssistantContext.Provider value={{ access }}>{children}</AssistantContext.Provider>;
});

export { AssistantProvider };
